import { LinkSource } from "@app/hooks/useTokenizedLinks";
import { HEAP_EVENTS } from "@app/provider/types";
import { IDP_TYPE } from "@app/service/user";

type SendTokenizedOrOrganicHeapEventProps = {
  invite: string | null;
  tokenizedEventName: HEAP_EVENTS;
  organicEventName: HEAP_EVENTS;
  method: IDP_TYPE;
  source?: LinkSource;
};

export const sendTokenizedOrOrganicHeapEvent = async ({
  invite,
  tokenizedEventName,
  organicEventName,
  method,
  source,
}: SendTokenizedOrOrganicHeapEventProps) => {
  if (invite) {
    heap.track(tokenizedEventName, {
      method,
      source,
    });
  } else {
    heap.track(organicEventName, { method });
  }
};
